import React from "react";

/**
 * Shared paper-craft template gallery. Used by Wedding/Save-Date/Shower/Baby
 * "choose a template" pages. Parents pass the array of templates because CRA
 * webpack needs static `require()` paths — they can't be derived from a prop.
 */
export default function TemplateGrid({ templates, customFormPath, onSelect }) {
  return (
    <section className="pc-section papercraft pc-section--alt">
      <div className="pc-templates">
        {templates.map((t) => (
          <button
            key={t.id}
            type="button"
            className="pc-template-card"
            onClick={() => onSelect(t.id)}
          >
            <div className="pc-template-card__frame">
              <img src={t.image} alt={t.name} />
            </div>
            <h3 className="pc-template-card__name">{t.name}</h3>
            {t.tag && <span className="pc-template-card__tag">{t.tag}</span>}
          </button>
        ))}
      </div>

      <div className="pc-templates-cta">
        <p className="pc-templates-cta__heading">
          Have something specific in mind? We'll design it from scratch.
        </p>
        <a className="pc-templates-cta__btn" href={customFormPath}>
          Design it yourself
        </a>
      </div>
    </section>
  );
}
